import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import SentList from "./partials/ReceivedList";
import { Route, Routes } from "react-router-dom";
import { Toast } from "primereact/toast";
import qs from "qs";
import { getFromStorage, setToStorage } from "../../../../utils/Helper";
import { isEmpty } from "lodash";
import UrlHelper from "js-url-helper";
import moment from "moment";

const url = new UrlHelper();

const getDefaultReceivedWebhookFilters = () => ({
    fromDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    statuses: ['pending'],
});

const WebhookReceived = (props: any) => {
    const { t } = props;
    const toast = useRef(null);
    const [dropdowns] = useState<any>(null);
    const [moduleState, setModuleState] = useState<any>({
        page: 1,
        per_page: 20,
        search: null,
        initialized: false,
    });

    useEffect(() => {
        document.title = `ALP ${ t("webhook") }`;
        const prevUrl = qs.parse(url.getSearchParam().prev_url ?? "");
        const fromStorage: any = getFromStorage('supplierWebhookReceiverModuleState');
        const storedState = !isEmpty(fromStorage) ? JSON.parse(fromStorage) : {};
        const defaultFilters = getDefaultReceivedWebhookFilters();
        const defaultState = {
            page: !isEmpty(prevUrl.page) ? url.getSearchParam().page : 1,
            per_page: !isEmpty(prevUrl.per_page) ? url.getSearchParam().per_page : 20,
            search: !isEmpty(prevUrl.search) ? url.getSearchParam().search : null,
            initialized: true,
            sort_field: null,
            sort_order: null,
            ...storedState,
            filters: {
                ...defaultFilters,
                ...(storedState.filters ?? {}),
            },
        }

        setModuleState(defaultState);
        setToStorage('supplierWebhookReceiverModuleState', JSON.stringify(defaultState));
    }, []);

    const toastify = (message: any, color: string = 'info', summary: any = null) => {
        if ( toast && toast.current ) {
            // @ts-ignore
            toast.current.show({ severity: color, summary: summary, detail: message });
        }
    };

    const setQuery = (value: any) => {
        setToStorage('supplierWebhookReceiverModuleState', JSON.stringify(value));
        setModuleState(value);
    }

    return (
        <div className={ "module-container" }>
            <Toast ref={ toast } />
            <div className="layout-content">
                { ( moduleState && moduleState.initialized ) ?
                    <React.Fragment>
                        <Routes>
                            <Route path={ "/" } element={
                                <SentList
                                    moduleState={ moduleState }
                                    dropdowns={ dropdowns }
                                    toastify={ toastify }
                                    setQuery={ setQuery }
                                /> } />
                        </Routes>
                    </React.Fragment>
                    : <h6>{ t('loading') }</h6> }
            </div>
        </div>
    );
};

// WebhookReceived.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(WebhookReceived);
